import Staff from "@/pages/Staff";
import Branches from "@/pages/Branches";
import Settings from "@/pages/Settings";

export const ADMIN_WORKSPACE_ROUTES = [
  { path: "/staff", element: Staff, permission: "staff_access" },
  { path: "/branches", element: Branches, permission: "branch_management" },
  { path: "/settings", element: Settings, permission: "settings" },
];
